// extracted by mini-css-extract-plugin
export default {"root":"navy-modal_root__zztpg","noLongPress":"navy-modal_noLongPress__rEaL8"};